import { render, staticRenderFns } from "./PatentInfo.vue?vue&type=template&id=0dc65103&scoped=true"
import script from "./PatentInfo.vue?vue&type=script&setup=true&lang=ts"
export * from "./PatentInfo.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./PatentInfo.vue?vue&type=style&index=0&id=0dc65103&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dc65103",
  null
  
)

export default component.exports